import React, {useEffect, useMemo, useState} from "react";
import {Tree} from "primereact/tree";
import {addLocale, locale} from "primereact/api";
import i18nPrimeReact from "../utils/locale-prime-react.json"
import InputForm from "../input/input-form.jsx";
import './tree-users.css'

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;
const TreeUsers = ({users}) => {
    const [usersTree, setUsersTree] = useState([])
    const [expandedKeys, setExpandedKeys] = useState({});
    const filteredUsers = useMemo(() => ({
        actives: users.filter(el => el.status),
        inactives: users.filter(el => !el.status)
    }), [users]);

    useEffect(() => {
        addLocale("pt-br", i18nPrimeReact);
        locale("pt-br");
    }, []);

    const prepareUsersToTree = (active = true) => {
        const userToUse = active ? filteredUsers.actives : filteredUsers.inactives;


        if (userToUse.length === 0) {
            return [{key: -1, label: `Não há agentes`, children: []}];
        }

        return userToUse.map(user => {
            return {key: user.id, label: `${user.name} (${user.login ?? ""})`, children: []};
        });
    }

    const usersToTree = () => {
        const tree = [
            {
                key: `0-0`,
                label: `Ativos (${filteredUsers.actives.length})`,
                children: prepareUsersToTree()
            },
            {
                key: `0-1`,
                label: `Inativos (${filteredUsers.inactives.length})`,
                children: prepareUsersToTree(false)
            }
        ];

        setUsersTree(tree);
    }

    useEffect(() => {
        usersToTree()
    }, [users]);

    useEffect(() => {
        setExpandedKeys({ "0-0": true});
    }, [usersTree]);

    const templateToTree = (node, options) => {
        const {children, label, key} = node;

        if (children.length > 0) {
            return (
                <span className="p-treenode-label">{label}</span>
            );
        }

        if (key === -1) {
            return (
                <div key={key}>
                    <span>{label}</span>
                </div>
            );
        }

        return (
            <div className={"pl-1 user"} key={key}>
                <a href={`${BASENAME}user-agents/form/${key}`} target={"_blank"}>
                    <div className="img-thumbnail"
                         style={{backgroundImage: `url(${API_URL}/user/getImage/${key})`}}></div>
                    <span>{label}</span>
                </a>
            </div>
        );
    }

    const filterTemplate = (node) => {
        return (
            <InputForm  label='Pesquisar agentes'
                        id="user_tree_search"
                        type='search'
                        classNameWrapper="mt-2"
                        onChange={node.filterInputChange}
                        onKeyDown={node.filterInputKeyDown}/>
        );
    }

    return (
        <div className="user-list">
            <Tree filter
                  filterTemplate={filterTemplate}
                  value={usersTree}
                  expandedKeys={expandedKeys}
                  nodeTemplate={templateToTree}
                  onToggle={e => setExpandedKeys(e.value)}
            />
        </div>
    )
}

export default TreeUsers